import closeIcon from "@assets/images/close-thin.svg";
import zipIcon from "@assets/images/zip.svg";
import { Box, Typography } from "@material-ui/core";
import React from "react";
import SVG from "react-inlinesvg";

import useStyle from "./styles";

const FileLine = ({
  path,
  onRemove
}: {
  path: string;
  onRemove: () => void;
}) => {
  const classes = useStyle();

  return (
    <Box
      alignItems="center"
      display="flex"
      className={classes.uploadResult}
      style={{
        marginTop: path ? "8px" : "0px",
        marginBottom: path ? "8px" : "0px",
        paddingTop: path ? "4px" : "0px",
        paddingBottom: path ? "4px" : "0px",
        paddingRight: path ? "16px" : "0px",
        paddingLeft: path ? "16px" : "0px",
        background: "#F2FAFB",
        borderBottom: "0px",
        position: "relative"
      }}
    >
      {path && (
        <React.Fragment>
          <SVG src={zipIcon} className={classes.icon} />
          <Typography
            className={classes.fileName}
            style={{
              display: "block",
              overflowWrap: "break-word",
              wordWrap: "break-word",
              wordBreak: "break-all",
              maxWidth: "60ch"
            }}
          >
            {path}
          </Typography>

          <SVG
            data-testid="close-icon-file-line"
            src={closeIcon}
            className={classes.iconClose}
            onClick={onRemove}
          />
        </React.Fragment>
      )}
    </Box>
  );
};

export default FileLine;
